let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFF5s"), load("gWoEm"), load("ffEVr"), load("iCuQy")]).then(() => parcelRequire('4Shbp'));